/**
 * Codes retired from the fee schedule (Fee Schedule Update, tab FS-4). They are never offered when
 * adding services, whichever ValueSet lists them. Past services that used them keep their names.
 */
export const RETIRED_PROCEDURE_CODES: ReadonlySet<string> = new Set([
  "0500F",
  "0501F",
  "0502F",
  "0503F",
  "36406",
  "57170",
  "58321",
  "58322",
  "59020",
  "76820",
  "76821",
  "76827",
  "76828",
  "96160",
  "96374",
  "97022",
  "97803",
  "99058",
  "99071",
  "993X0",
  "A4261",
  "A4266",
  "A4550",
  "J0295",
  "J3105",
  "J7040",
  "Q0091",
  "S0077",
]);
